export default "__VITE_ASSET__34092763__"